import { SettingsHeader } from "../index";
import PDFTemplates from "../Templates/PDFTemplates";

/**
 * Settings page wrapper for trucking PDF template management.
 */
const PDFTemplatesSettings = () => {
  return (
    <div className="space-y-4">
      <SettingsHeader title="PDF Templates" />
      <PDFTemplates embedded />
    </div>
  );
};

export default PDFTemplatesSettings;
